import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { Tooltip, Grid, TextField, InputAdornment } from "@material-ui/core";
import { SearchIcon } from "@icarius-icons/";
import { searchTransactionLogAction } from "../actions";
import { getLocalizedString } from "@icarius-localization/strings";

const SearchInput = ({ gridRef }) => {
    const [searchInput, setSearchInput] = useState("");

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);

    const handleSearch = () => {
        let filterComponent;
        if (!Boolean(searchInput)) {
            filterComponent = gridRef.api.getFilterInstance("internalCode");
            filterComponent.resetFilterValues();
            gridRef.api.onFilterChanged();
            return;
        }

        dispatch(searchTransactionLogAction(searchInput)).then((resp) => {
            if (resp?.status === 200) {
                const keysToSelect = resp.data.result;
                filterComponent = gridRef.api.getFilterInstance("internalCode");
                filterComponent.setModel({ values: keysToSelect });
                gridRef.api.onFilterChanged();
            }
        });
    };

    return (
        <Tooltip title={getLocalizedString("searchLabel")}>
            <Grid container alignItems="center" style={{ flexWrap: "nowrap" }}>
                <TextField
                    style={{ width: 300, marginRight: 5 }}
                    margin={"none"}
                    label={getLocalizedString("searchLabel")}
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === "Enter") {
                            handleSearch();
                            e.preventDefault();
                        }
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ fill: color, cursor: "pointer" }} onClick={handleSearch} />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </Tooltip>
    );
};

export default SearchInput;
